import { createSlice } from '@reduxjs/toolkit'
import type { AppConfig, AppState } from './types'

export const initialAppState: AppState = {
  language: 'en',
  config: {
    landingPath: '',
    name: '',
    exemptFromAuthentication: false,
    livePositionData: false,
    liveSessionData: false,
    liveEventStream: false,
    pitchSide: false,
    routes: []
  },
  keyboardShortcutsEnabled: true,
  isCloudApp: true,
  version: 'unknown'
}

export const appSlice = createSlice({
  name: 'app',
  initialState: initialAppState,
  reducers: {
    setLanguage: (state, action: { payload: AppState['language'] }) => {
      state.language = action.payload
    },
    setKeyboardShortcutsEnabled: (state, action: { payload: boolean }) => {
      state.keyboardShortcutsEnabled = action.payload
    },
    // Update config during HMR
    // This action allows the HMR system to update the app config in Redux state
    // without recreating the entire store (which would lose all other state)
    updateConfig: (state, action: { payload: AppConfig }) => {
      state.config = action.payload
    }
  }
})

export const reducer = appSlice.reducer

export const { setLanguage, setKeyboardShortcutsEnabled, updateConfig } =
  appSlice.actions

// Example thunk function for asynchronous operations
// export function exampleThunk(): AppThunk {
//   return async (dispatch) => {
//     // Intentionally left blank as a boilerplate example
//     // e.g., dispatch(someAction())
//   }
// }
